import { AxiosError } from "axios";

export enum IErrorType {
    AXIOS,
    NATIVE,
}

export interface IError {
    errorType: IErrorType;
    data: AxiosError["response"]["data"] | Error;
}
